// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { modalButtonsActionStyles } from "@eisinc/XDL/Utilities";
import { savedOrderDetailsAddressModalStyles } from "@insite/content-library/Widgets/SavedOrderDetails/SavedOrderDetailsAddressModal";
import { css } from "styled-components";

savedOrderDetailsAddressModalStyles.buttonsWrapper = {
    css: css`
        margin-top: 16px;
        ${modalButtonsActionStyles.buttonsGridItem?.css}
    `,
};

savedOrderDetailsAddressModalStyles.cancelButton = { ...modalButtonsActionStyles.cancelButton };

savedOrderDetailsAddressModalStyles.continueButton = { ...modalButtonsActionStyles.submitButton };
